const clearPlanDoctorsFromSessionStorage = () => {
  for (let i = 0; i < sessionStorage.length; i++) {
    const key = sessionStorage.key(i);
    if (key && key.startsWith("planDoctors")) {
      sessionStorage.removeItem(key);
    }
  }
  sessionStorage.removeItem("doctorProviderID");
  sessionStorage.removeItem("choosen_doctor");
};

export default clearPlanDoctorsFromSessionStorage;
